import { ChainId } from '@morpho-org/blue-sdk'

// Legal-driven deny list for market actions; edit this file as the market-action policy source.
export const RESTRICTED_MARKET_COUNTRIES = ['US', 'GB', 'CA', 'CH'] as const

// Scoped to Robinhood, where ERC-8056 instruments live: all 32 positives across the app's 4,874
// assets; the same token on another chain is intentionally not covered.
export const RESTRICTED_MARKET_CHAIN_ID = ChainId.RobinhoodMainnet
// ERC-8056 / IScaledUIAmount. Verified true for TSLA, SPY, SGOV, CRCL, and ORCL;
// false for USDG, csUSDG, csWETH, and a bogus interface id on Robinhood.
export const RESTRICTED_MARKET_INTERFACE_ID = '0xa60bf13d' as const

export const MARKET_GEO_RESTRICTION_MESSAGE = 'Unavailable in your region'
